import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

const GetGlycerinPriceFragment = graphql(/* GraphQL */ `
  fragment GetGlycerinPriceFragment on ProductPrice {
    value
    valueOld
    currency
  }
`);

export type GetGlycerinPriceProps = FragmentType<typeof GetGlycerinPriceFragment>;

export const getGlycerinPrice = (price: GetGlycerinPriceProps) => {
  const { currency, value, valueOld } = getFragmentData(GetGlycerinPriceFragment, price);

  return {
    displayedPrice: value,
    currency,
    originalPrice: valueOld || undefined,
  };
};
